var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 714,
    height: 715,
    viewBox: "0 0 714 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M714 315.826V398.222L359.155 357.048L690.918 499.895L649.496 571.248L359.203 357.095L574.648 645.646L502.865 686.82L354.845 357.048L400.577 714.047H317.684L359.107 357.048L215.397 686.82L143.614 645.646L359.059 357.095H354.749L68.862 571.152L27.4394 499.8L354.893 357L0 398.174V315.778L354.845 356.952L27.3915 214.152L68.8141 142.8L354.797 356.952L143.71 68.4488L215.493 27.2748L354.845 357.048H359.155L502.865 27.2272L574.648 68.4012L359.203 356.952L649.496 142.8L690.918 214.152L359.155 357L714 315.826ZM400.577 0L354.845 352.716L317.732 0H400.625H400.577Z",
    fill: "url(#paint0_radial_35_2681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_35_2681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(358.437 358.142) scale(357.766 355.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFCC00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.114543a197721c00729914f25ffb9651.svg";
export { ForwardRef as ReactComponent };